import {
  createLocale,
  zhCN,
  zhTW,
  enGB,
  dateZhCN,
  dateZhTW,
  dateEnGB,
  dateEsAR,
  dateDeDE,
  dateFrFR,
  datePtBR,
  dateRuRU,
  dateArDZ,
  dateJaJP,
  dateKoKR,
  dateItIT,
  dateNlNL,
  dateThTH,
  dateViVN,
  dateTrTR,
  dateFaIR,
  dateIdID,
  dateSvSE,
  datePlPL,
  dateCsCZ,
  dateNbNO
} from 'naive-ui'
import { $t } from '.'
export default function useUiLibLocale() {
  const customizedLocale = ref(zhCN)
  function customizeUiLibLocale(locale: string) {
    const map: Record<string, typeof zhCN | undefined> = {
      en: enGB,
      'zh-CN': zhCN,
      'zh-HK': zhTW
    }
    return createLocale(
      {
        global: {
          undo: $t('lib_navie-ui_global_undo'),
          redo: $t('lib_navie-ui_global_redo'),
          confirm: $t('lib_navie-ui_global_confirm'),
          clear: $t('lib_navie-ui_global_clear')
        },
        Popconfirm: {
          positiveText: $t('lib_navie-ui_Popconfirm_positiveText'),
          negativeText: $t('lib_navie-ui_Popconfirm_negativeText')
        },
        Cascader: {
          placeholder: $t('lib_navie-ui_Cascader_placeholder'),
          loading: $t('lib_navie-ui_Cascader_loading'),
          loadingRequiredMessage: (label) =>
            $t('lib_navie-ui_Cascader_loadingRequiredMessage', { label })
        },
        DatePicker: {
          clear: $t('lib_navie-ui_DatePicker_clear'),
          now: $t('lib_navie-ui_DatePicker_now'),
          confirm: $t('lib_navie-ui_DatePicker_confirm'),
          selectTime: $t('lib_navie-ui_DatePicker_selectTime'),
          selectDate: $t('lib_navie-ui_DatePicker_selectDate'),
          datePlaceholder: $t('lib_navie-ui_DatePicker_datePlaceholder'),
          datetimePlaceholder: $t('lib_navie-ui_DatePicker_datetimePlaceholder'),
          monthPlaceholder: $t('lib_navie-ui_DatePicker_monthPlaceholder'),
          yearPlaceholder: $t('lib_navie-ui_DatePicker_yearPlaceholder'),
          quarterPlaceholder: $t('lib_navie-ui_DatePicker_quarterPlaceholder'),
          weekPlaceholder: $t('lib_navie-ui_DatePicker_weekPlaceholder'),
          startDatePlaceholder: $t('lib_navie-ui_DatePicker_startDatePlaceholder'),
          endDatePlaceholder: $t('lib_navie-ui_DatePicker_endDatePlaceholder'),
          startDatetimePlaceholder: $t('lib_navie-ui_DatePicker_startDatetimePlaceholder'),
          endDatetimePlaceholder: $t('lib_navie-ui_DatePicker_endDatetimePlaceholder'),
          startMonthPlaceholder: $t('lib_navie-ui_DatePicker_startMonthPlaceholder'),
          endMonthPlaceholder: $t('lib_navie-ui_DatePicker_endMonthPlaceholder'),
          today: $t('lib_navie-ui_DatePicker_today')
        },
        DataTable: {
          checkTableAll: $t('lib_navie-ui_DataTable_checkTableAll'),
          uncheckTableAll: $t('lib_navie-ui_DataTable_uncheckTableAll'),
          confirm: $t('lib_navie-ui_DataTable_confirm'),
          clear: $t('lib_navie-ui_DataTable_clear')
        },
        LegacyTransfer: {
          sourceTitle: $t('lib_navie-ui_LegacyTransfer_sourceTitle'),
          targetTitle: $t('lib_navie-ui_LegacyTransfer_targetTitle')
        },
        Transfer: {
          selectAll: $t('lib_navie-ui_Transfer_selectAll'),
          clearAll: $t('lib_navie-ui_Transfer_clearAll'),
          unselectAll: $t('lib_navie-ui_Transfer_unselectAll'),
          total: (num) => $t(`lib_navie-ui_Transfer_total`, { num }),
          selected: (num) => $t(`lib_navie-ui_Transfer_selected`, { num })
        },
        Empty: {
          description: $t('lib_navie-ui_Empty_description')
        },
        Select: {
          placeholder: $t('lib_navie-ui_Select_placeholder')
        },
        TimePicker: {
          placeholder: $t('lib_navie-ui_TimePicker_placeholder'),
          positiveText: $t('lib_navie-ui_TimePicker_positiveText'),
          negativeText: $t('lib_navie-ui_TimePicker_negativeText'),
          now: $t('lib_navie-ui_TimePicker_now'),
          clear: $t('lib_navie-ui_TimePicker_clear')
        },
        Pagination: {
          goto: $t('lib_navie-ui_Pagination_goto'),
          selectionSuffix: $t('lib_navie-ui_Pagination_selectionSuffix')
        },
        DynamicTags: {
          add: $t('lib_navie-ui_DynamicTags_add')
        },
        Log: {
          loading: $t('lib_navie-ui_Log_loading')
        },
        Input: {
          placeholder: $t('lib_navie-ui_Input_placeholder')
        },
        InputNumber: {
          placeholder: $t('lib_navie-ui_InputNumber_placeholder')
        },
        DynamicInput: {
          create: $t('lib_navie-ui_DynamicInput_create')
        },
        ThemeEditor: {
          title: $t('lib_navie-ui_ThemeEditor_title'),
          clearAllVars: $t('lib_navie-ui_ThemeEditor_clearAllVars'),
          clearSearch: $t('lib_navie-ui_ThemeEditor_clearSearch'),
          filterCompName: $t('lib_navie-ui_ThemeEditor_filterCompName'),
          filterVarName: $t('lib_navie-ui_ThemeEditor_filterVarName'),
          import: $t('lib_navie-ui_ThemeEditor_import'),
          export: $t('lib_navie-ui_ThemeEditor_export'),
          restore: $t('lib_navie-ui_ThemeEditor_restore')
        },
        Image: {
          tipPrevious: $t('lib_navie-ui_Image_tipPrevious'),
          tipNext: $t('lib_navie-ui_Image_tipNext'),
          tipCounterclockwise: $t('lib_navie-ui_Image_tipCounterclockwise'),
          tipClockwise: $t('lib_navie-ui_Image_tipClockwise'),
          tipZoomOut: $t('lib_navie-ui_Image_tipZoomOut'),
          tipZoomIn: $t('lib_navie-ui_Image_tipZoomIn'),
          tipDownload: $t('lib_navie-ui_Image_tipDownload'),
          tipClose: $t('lib_navie-ui_Image_tipClose'),
          tipOriginalSize: $t('lib_navie-ui_Image_tipOriginalSize')
        }
      },
      map[locale] ?? enGB
    )
  }
  const customizedDateLocale = ref(dateZhCN)

  function customizeUiLibDateLocale(locale: string) {
    const map: Record<string, typeof dateZhCN | undefined> = {
      en: dateEnGB,
      'zh-CN': dateZhCN,
      'zh-HK': dateZhTW,
      es: dateEsAR,
      de: dateDeDE,
      fr: dateFrFR,
      pt: datePtBR,
      ru: dateRuRU,
      ar: dateArDZ,
      ja: dateJaJP,
      ko: dateKoKR,
      it: dateItIT,
      nl: dateNlNL,
      th: dateThTH,
      hi: undefined,
      vi: dateViVN,
      ms: undefined,
      tr: dateTrTR,
      fa: dateFaIR,
      el: undefined,
      id: dateIdID,
      bn: undefined,
      fil: undefined,
      sr: undefined,
      sv: dateSvSE,
      sw: undefined,
      pl: datePlPL,
      cs: dateCsCZ,
      fi: undefined,
      no: dateNbNO,
      da: undefined
    }
    return map[locale] ?? dateEnGB
  }

  function setLocale(locale: string) {
    customizedLocale.value = customizeUiLibLocale(locale)
    customizedDateLocale.value = customizeUiLibDateLocale(locale)
    // document.documentElement.lang = locale
  }

  return {
    customizedLocale,
    customizedDateLocale,
    setLocale
  }
}
